export default __webpack_public_path__ + "static/media/1779.777e0826.png";